const languageDatatable = {
    processing: '<div class="card-loading reveal"><div class="spinner-dots"><span class="dot1"></span><span class="dot2"></span><span class="dot3"></span></div></div>',
    search: 'Rechercher&nbsp;:',
    lengthMenu: '_MENU_',
    loadingRecords: 'Chargement en cours...',
    zeroRecords: 'Aucun &eacute;l&eacute;ment &agrave; afficher',
    emptyTable: 'Aucun &eacute;l&eacute;ment',
    info: 'Page _PAGE_ sur  _PAGES_',
    paginate: {
      first: 'Premier',
      previous: 'Pr&eacute;c&eacute;dent',
      next: 'Suivant',
      last: 'Dernier'
    }
  }
  
  export default languageDatatable
  